import { render, staticRenderFns } from "./seller-management.vue?vue&type=template&id=51fbb798&scoped=true&"
import script from "./seller-management.vue?vue&type=script&lang=js&"
export * from "./seller-management.vue?vue&type=script&lang=js&"
import style0 from "./seller-management.vue?vue&type=style&index=0&id=51fbb798&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51fbb798",
  null
  
)

export default component.exports